import { createFileRoute } from "@tanstack/react-router";
import { AdminProductsPage } from "../components/shop/admin-products-page.tsx";

export const Route = createFileRoute("/produkter/")({ component: AdminProductsPage });
